import styled from 'styled-components';
import { OffersListStyled } from '../OffersListStyled';

export const OffersListStyledAC = styled(OffersListStyled)``;
